import React, { useState, useEffect } from 'react';
import DataResource from '../../../../common/v4/DataResource'
import Panel from '../../../../common/layout/Panel'
import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../../common/EditPage';
import { getOne, update } from './../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

const view = (props) => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { rate_id } = useParams();

    useEffect(() => {
        getOne(`/admin/products/sms/rates/`, rate_id )
            .then(response => {
                setData(response.data.data);
                setLoading(false);
            });
    }, []);

    const handleSave = () => {
        update(`/admin/products/sms/rates/`, rate_id, {data: data})
            .then(response => {
                toast.success('SMS Rate Table updated successfully');
            }).catch(error => {
                toast.error(error.message);
            });
    }

    const handleCancel = () => {
        navigate('/products/sms/rates');
    }

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    }

    const resData = {
            url: `/admin/products/sms/rates/${rate_id}/items`,
            data: {
                data: [],
                metadata: []
            },
            userfilter: [
                {
                    source: 'description',
                    label: 'Description',
                    type: 'text'
                },
                {
                    source: 'prefix',
                    label: 'Prefix',
                    type: 'text'
                },
                {
                    source: 'effective_from',
                    label: 'Effective From',
                    type: 'select',
                    default: 'current',
                    editable: true,
                },
            ],
            userFilterExpandable: true,
            userFilterSimple: true,
            metadata: [
                {
                    label: 'ID',
                    source: 'ATRSMSRATEITEMID',
                    type: 'primary',
                    visible: false
                },
                {
                    label: 'Destination',
                    source: 'ATRSMSMASTERCODEID',
                    type: 'select',
                    placeholder: 'Prefix'
                },
                {
                    label: 'Rate',
                    source: 'ATRRATE',
                    type: 'text',
                    placeholder: '0.00',
                    default: 0.00,
                    editable: true,
                },  
                {
                    label: 'Currency',
                    source: 'ATRCURID',
                    type: 'select',
                    editable: true,
                }, 
                {
                    label: 'Effective From',
                    source: 'effective_from',
                    type: 'datetime',
                    
                    editable: true,
                }, 
                {
                    label: 'Expiry',
                    source: 'expiry',
                    type: 'icon',
                    values : {
                        FUTURE: 'FUTURE',
                        CURRENT: 'CURRENT',
                        EXPIRED: 'EXPIRED'
                    },
                    classnames : {
                        FUTURE: 'label label-warning',
                        CURRENT: 'label label-info',
                        EXPIRED: 'label label-danger'
                    }
                },
                {
                    label: 'Enabled',
                    source: 'ATRSTATUS',
                    type: 'boolean',
                    default: true,
                    editable: true,
                },
                { 
                    label: 'Deleted',
                    type: 'delete',
                }

            ]
        }

    return (
            <Panel title = {`SMS Rate Table Name: ${data.ATRNAME}`}>
                <div>
                    <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title={`Update SMS Rate Table: ${data.ATRNAME}`}>
                        <EditPagePanel>
                            <EditPageTextField label="Name" id="ATRNAME" onChange={ onChange } value={ data.ATRNAME } />
                            <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                        </EditPagePanel>
                    </EditPage>
                <DataResource 
                    loading = {loading}
                    data = {resData}
                    {...props}  
                    addButtonText = "Create Item" 
                    addButtonLink = {`/products/sms/rates/${rate_id}/items/new`}/>
                </div>
            </Panel>
        )
    
}

export default view;
